import router from "@/router/index.js";
import { useAuthStore } from "@/stores/AuthStore";
import axios from "axios";
import "vuetify-sonner/style.css";

// Request interceptor
axios.interceptors.request.use(
	config => {
		if (
			config.url != "https://zipcloud.ibsnet.co.jp/api/search" &&
			config.method != "get"
		)
			config.headers = { "Content-Type": "application/json" };
		config.headers = {
			...{ "Content-Type": "application/json", Accept: "application/json" },
			...(config.header ?? {})
		};
		showAlert = config.showAlert ?? true;

		return config;
	},
	error => {
		return Promise.reject(error);
	}
);

// Response interceptor
axios.interceptors.response.use(
	response => {
		// 外部API対応
		if (response.data.hasOwnProperty("results")) {
			return response;
		} else {
			return handleResponse(response);
		}
	},
	error => {
		handleError(error.response.status);
	}
);

function handleResponse(response) {
	// const loader = useLoaderStore();
	// ステータスコード
	let status = getStatus(response);

	// APIの中身
	let data = getData(response);

	// 実行結果
	let result = isError(data);

	// validメッセージ
	let errors = getErrors(data);

	// APIメッセージ
	let alertMessage = getAlertMessage(data);

	// ローディング処理を停止
	setTimeout(() => {
		// loader.stopLoading();
		if (result) {
			if (hasAlertMessage(data)) {
				if (isObject(alertMessage)) {
					for (const key in alertMessage) {
						// alert("success", "", alertMessage[key]);
					}
				} else {
					// alert("success", "", data.alert);
				}
			}

			// 成功時（getメソッド以外で使用）
			if (!errors.length && !alertMessage) {
				if (response.config.method != "get") {
					// alert("success", "", alertSuccessMessage[response.config.method]);
				}
			}
		}

		if (!result) {
			if (alertMessage) {
				if (isObject(alertMessage)) {
					for (const key in alertMessage) {
						// alert("error", "", alertMessage[key]);
					}
				} else {
					// alert("error", "", data.alert);
				}
			}

			if (errors.length) {
				// alert("error", "", "入力項目に誤りがあります");
			}
		}
	}, 300);

	// 通信失敗時 Check if the status code is in the success range (200-299)
	if (!(response.status >= 200 && response.status < 300)) {
		handleError(status);
	}

	data = { ...data, ...{ code: status } };
	return data;
}

/*
|--------------------------------------------------------------------------
| 静的プロパティ
| ここでは成功、失敗などで利用するフラッシュメッセージの文章を設定
| staticを利用するときは 例）ApiFunction（親クラス名）.alertType
|--------------------------------------------------------------------------|
*/

const alertType = {
	success: {
		title: "Success !!",
		message: "処理が完了しました。"
	},
	info: {
		title: "Info !!",
		message: "追加情報があります。"
	},
	warning: {
		title: "Warning !!",
		message: "処理が完了しましたが、問題が発生しました。"
	},

	error: {
		title: "Error !!",
		message: "通信処理に失敗しました。"
	}
};

const alertSuccessMessage = {
	post: "登録処理が完了しました。",
	put: "更新を完了しました。",
	delete: "データを削除しました。",
	get: "データをロードしました。"
};

let showAlert = true;

/*
|--------------------------------------------------------------------------
| ステータスコードを取得（200,404,500など）
|--------------------------------------------------------------------------|
*/
function getStatus(data) {
	return data.status;
}

/*
|--------------------------------------------------------------------------
| API通信で値を取得
|--------------------------------------------------------------------------|
*/
function getData(result) {
	return result.data;
}

/*
|--------------------------------------------------------------------------
| APIメッセージの取得
|--------------------------------------------------------------------------|
*/
function getAlertMessage(data) {
	return !data.alert || !data.alert.length ? null : data.alert;
}

/*
|--------------------------------------------------------------------------
| APIエラーメッセージの取得
|--------------------------------------------------------------------------|
*/
function getErrors(data) {
	let array = [];
	if (data.errors && Object.keys(data.errors).length) {
		for (let key in data.errors) {
			array.push(data.errors[key]);
		}
	}
	return array;
}

/*
|--------------------------------------------------------------------------
| エラー判定
|--------------------------------------------------------------------------|
*/
function isError(data) {
	return !data.result == false;
}

function hasAlertMessage(data) {
	return data.alert && data.alert.length;
}

/*
|--------------------------------------------------------------------------
| statusCODEが異常なら遷移させます
| 401の場合のみログイン状態を解除し、ログイン画面へ遷移させます
|--------------------------------------------------------------------------|
*/
function handleError(status) {
	const authStore = useAuthStore();
	// 正常
	if (status == 200 || status == 204) return;
	if (status == 404) {
		router.push("/404");
		return;
	}
	if (status == 419) {
		// alert("error", "失敗しました（CODE:" + status + "）再読込してください。");
		return;
	}
	if (status == 500) {
		// alert("error", "失敗しました（CODE:" + status + "）");
		return;
	}
	// 401 {Unauthenticated}
	if (status == 401 || status == 302) {
		authStore.$reset();
		router.push("/signin");
		return;
	}
	// その他
	// alert("error", "失敗しました（CODE:" + status + "）");
}

/*
|--------------------------------------------------------------------------
| 登録時の成功、失敗通知
|--------------------------------------------------------------------------|
*/
function alert(type, header, message) {
	if (showAlert) {
		header = !header ? alertType[type]["title"] : header;
		message = !message ? alertType[type]["message"] : message;

		if (type == "success") {
			toast.success(header, {
				position: "bottom-right",
				description: message
			});
		} else if (type == "error") {
			toast.error(header, {
				position: "bottom-right",
				description: message
			});
		}
	}
}

function isObject(value) {
	return typeof value === "object" && value !== null && !Array.isArray(value);
}

export default axios;
